import React from 'react';
import { Col } from 'antd';



const HeaderText = () => {
  return (
    <Col className="hp-header-left-text hp-d-flex-center" style={{ width: '88%' }} />
  );
};

export default HeaderText;
